import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";

interface BudgetRangeInputProps {
  budgetRange: {
    min: number;
    max: number;
  };
  onBudgetChange: (type: 'min' | 'max', value: number) => void;
}

export const BudgetRangeInput = ({ budgetRange, onBudgetChange }: BudgetRangeInputProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label>Budget Range (per night)</Label>
        <div className="text-sm text-muted-foreground">
          ${budgetRange.min} - ${budgetRange.max}
        </div>
      </div>

      <div className="space-y-6">
        <div>
          <Label className="text-sm">Minimum Budget</Label>
          <Slider
            defaultValue={[budgetRange.min]}
            max={1000}
            step={10}
            onValueChange={(value) => onBudgetChange('min', value[0])}
          />
        </div>

        <div>
          <Label className="text-sm">Maximum Budget</Label>
          <Slider
            defaultValue={[budgetRange.max]}
            max={5000}
            step={50}
            onValueChange={(value) => onBudgetChange('max', value[0])}
          />
        </div>
      </div>
    </div>
  );
};